import { CnxIdType } from '@cnx-saas/utils-cnx-id';
import {
  BaseFilterOne,
  BaseFilterMany,
  BaseQueryMany,
  Contact,
  Address,
} from '@cnx-saas/common';
import { VehicleCapabilities } from '@cnx-saas/vehicles';
import {
  Location,
  LocationInput,
  LocationMasterDataInfoType,
  Locations,
} from './Location';
import { LocationDrivingTimeAndDistance } from './LocationTravelDetailsApi';

export class FilterLocation extends BaseFilterOne(CnxIdType.Location) {}
export class FilterLocations extends BaseFilterMany(CnxIdType.Location) {}

export class LocationFilters {
  externalReference?: string;
  address?: Partial<Address>;
  owned?: boolean;
  description?: string;
  company?: string;
  serviceTime?: number;
  contact?: Partial<Contact>;
  loadingRequirements?: VehicleCapabilities[];
  locationIds?: string[];
  withNoEmail?: boolean;
  withNoOpeningHours?: boolean;
  withNoTelephoneNumber?: boolean;
}
export class QueryLocations extends BaseQueryMany<LocationFilters>() {}

export interface LocationQueryVariables {
  filter: FilterLocation;
}
export interface LocationQueryResult {
  location: Location;
}

export interface LocationsQueryVariables {
  query: QueryLocations;
}
export interface LocationsQueryResult {
  locations: Locations;
}

export interface LocationsByExternalReferencesQueryVariables {
  externalReferences: string[];
}

export interface LocationsByIdsQueryVariables {
  locationIds: string[];
}

export interface LocationDrivingTimesAndDistancesResult {
  locationDrivingTimesAndDistances: LocationDrivingTimeAndDistance[];
}

export interface LocationInputFilter {
  id: string;
}

export interface LocationInputData {
  filter?: LocationInputFilter;
  locationInput: LocationInput;
}

// CHECK: if needed for frontend and backend e2e tests

// export interface CreateLocationMutationVariables {
//   locationInput: LocationInput;
// }

// export interface UpdateLocationMutationVariables {
//   filter: FilterLocation;
//   locationInput: LocationInput;
// }

// export interface DeleteLocationMutationVariables {
//   filter: FilterLocation;
// }

// export interface LocationMutationResult {
//   location: Location;
// }

// export type LocationsMutationResult = BaseBulk;

export interface LocationMasterDataFilter {
  infoType: LocationMasterDataInfoType;
}
